import { render, staticRenderFns } from "./OtherSupportSigein.vue?vue&type=template&id=7c579b82&"
import script from "./OtherSupportSigein.vue?vue&type=script&lang=js&"
export * from "./OtherSupportSigein.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports